
import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import uniq from 'lodash/uniq'
import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'
import { setupGtmCdpAction } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    audioWorks: { type: Array, required: false, default: () => [] },
    hasIntermission: { type: Boolean, required: false, default: false },
    intermissionDescription: { type: String, required: false, default: '' },
    musicians: { type: Array, required: false, default: () => [] },
    showIntermission: { type: Boolean, required: false, default: true },
    substitute: { type: String, required: false, default: '' },
    headerAudioIsPlaying: { type: Boolean, required: true },
    toggleHeaderAudio: { type: Function, required: true },
    program: { type: Object, required: false, default: undefined },
    theme: { type: String, required: false, default: undefined },
  },
  setup(props) {
    const hasAudioFragments = props.audioWorks.some((audioWork) => audioWork.audio?.url)
    const { t_ } = setupTranslationPrefixer('program')
    const showAllMusicians = ref(false)
    const gtmCdpAction = setupGtmCdpAction()

    const {
      app: { i18n },
    } = useContext()
    const items = ref([
      {
        label: i18n.t('concert.detail.has-intermission-title'),
        description:
          props.intermissionDescription ||
          (props.hasIntermission ? i18n.t('concert.detail.has-intermission') : props.showIntermission ? i18n.t('concert.detail.has-no-intermission') : undefined),
      },
    ])
    const normalizedMusicians = computed(() =>
      mapValues(
        groupBy(props.musicians, (musician) => musician.title),
        (musicians) => ({
          musician: musicians[0].title,
          instruments: uniq(musicians.map((musician) => musician.instrumentDescription).filter((value) => !!value)),
          roles: uniq(musicians.map((musician) => musician.role).filter((value) => !!value)),
        })
      )
    )

    const toggleShowAllMusicians = () => {
      showAllMusicians.value = !showAllMusicians.value
      if (showAllMusicians.value) {
        gtmCdpAction('CV07 - See all musici clicked')
      }
    }

    return {
      hasAudioFragments,
      items,
      normalizedMusicians,
      showAllMusicians,
      toggleShowAllMusicians,
      t_,
    }
  },
})
